export default "__VITE_ASSET__CZ6UhTP2__"